/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {CreateWrapper} from './container/CreateLocation'
import {ListWraper} from './container/List'

export function LocationPage() {
  useEffect(() => {}, [])

  return (
    <div>
      <Switch>
        <Route path='/location/list' exact={true} component={ListWraper} />
        <Route path='/location/create' exact={true} component={CreateWrapper} />
        <Redirect from='/location' exact={true} to='/location/list' />
        <Redirect to='/location/list' />
      </Switch>
    </div>
  )
}
